export enum DmsConnectionErrorType {
  FolderNotFound = 'https://errors.shine.co/advisor-dms-api/FOLDER_NOT_FOUND',
}
